import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, Undo2, Loader2 } from "lucide-react";
import api from "../../lib/api";

const M = ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"];

function MonthChips({ prev, value, onToggle, testId }) {
  return (
    <div className="flex flex-wrap gap-1" data-testid={testId}>
      {M.map((m, i) => {
        const on = value.includes(i + 1);
        const was = prev.includes(i + 1);
        return (
          <button key={m} type="button" onClick={() => onToggle(i + 1)} title={was ? "war vorher dabei" : "war vorher nicht dabei"}
            className="px-1.5 py-0.5 rounded text-[11px] border transition-colors"
            style={{ backgroundColor: on ? "var(--wp-olive, #5F5B3E)" : "transparent", color: on ? "#fff" : "inherit",
              borderColor: was ? "#5F5B3E" : "var(--wp-border)", borderStyle: was ? "solid" : "dashed", opacity: on || was ? 1 : 0.45 }}>
            {m}
          </button>
        );
      })}
    </div>
  );
}

function ReviewRow({ p, onDone }) {
  const [season, setSeason] = useState(p.season || []);
  const [busy, setBusy] = useState("");
  const changed = JSON.stringify([...season].sort((a, b) => a - b)) !== JSON.stringify(p.season || []);
  const toggle = (m) => setSeason(season.includes(m) ? season.filter((x) => x !== m) : [...season, m]);
  const act = async (action) => {
    setBusy(action);
    try {
      await api.post(`/admin/plants/${p.id}/season-review`, { action, season });
      toast.success(`${p.name_de}: ${action === "revert" ? "alte Saison wiederhergestellt" : "Saison bestätigt"}`);
      onDone(p.id);
    } catch (e) { toast.error(e?.response?.data?.detail || "Speichern fehlgeschlagen"); }
    finally { setBusy(""); }
  };
  return (
    <div className="rounded-xl border p-3 space-y-2" style={{ borderColor: "var(--wp-border)" }} data-testid={`season-review-${p.id}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="font-medium text-sm">{p.name_de}</div>
        <div className="flex gap-2">
          <button onClick={() => act(changed ? "set" : "confirm")} disabled={!!busy} className="inline-flex items-center gap-1 px-3 py-1 rounded-full border text-xs hover:bg-[var(--wp-cream)]" style={{ borderColor: "var(--wp-border)" }} data-testid={`season-confirm-${p.id}`}>
            {busy && busy !== "revert" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Check className="w-3.5 h-3.5" />} {changed ? "Geändert speichern" : "Bestätigen"}
          </button>
          <button onClick={() => act("revert")} disabled={!!busy} className="inline-flex items-center gap-1 px-3 py-1 rounded-full border text-xs hover:bg-[var(--wp-cream)]" style={{ borderColor: "var(--wp-border)" }} data-testid={`season-revert-${p.id}`}>
            {busy === "revert" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Undo2 className="w-3.5 h-3.5" />} Alte zurück
          </button>
        </div>
      </div>
      <div className="text-xs opacity-70">Vorher: {(p.season_prev || []).map((m) => M[m - 1]).join(", ") || "–"}</div>
      <MonthChips prev={p.season_prev || []} value={season} onToggle={toggle} testId={`season-chips-${p.id}`} />
      {p.season_note && <div className="text-xs opacity-70 italic">{p.season_note}</div>}
    </div>
  );
}

export default function SeasonReviewPanel() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/plants/season-review").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows) return <div className="text-xs opacity-60"><Loader2 className="w-3.5 h-3.5 inline animate-spin" /> Lädt Saison-Prüfung …</div>;
  return (
    <div className="space-y-2" data-testid="season-review-panel">
      <div className="text-sm font-medium">Saison prüfen ({rows.length} offen)</div>
      <p className="text-xs opacity-70">Ausgefüllt = neue Saison · durchgezogener Rand = war vorher dabei. Monate antippen zum Ändern.</p>
      {rows.length === 0 && <div className="text-xs opacity-60" data-testid="season-review-empty">Alles geprüft.</div>}
      <div className="grid md:grid-cols-2 gap-2">
        {rows.map((p) => <ReviewRow key={p.id} p={p} onDone={(id) => setRows(rows.filter((r) => r.id !== id))} />)}
      </div>
    </div>
  );
}
